import { Link } from 'react-router-dom';
import { typeOfBeansLinks } from './navigation';
import './styles.scss';

// 1. Asegúrate de que el PADRE le esté enviando esta prop (ej. <TypeOfBean productSlug={slugActual} />)
const TypeOfBean = ({ productSlug }) => { 
    
    // 2. Si no llega ningún slug del padre (ej. carga inicial), tomamos el primero de la lista
    const defaultSlug = typeOfBeansLinks.length > 0 ? typeOfBeansLinks[0].slug : null;
    const activeSlug = productSlug || defaultSlug;

    // 3. Comparamos los textos exactamente como hacías con los números
    const getActive = slug => {
        if (activeSlug === slug) return 'active';
    };

    return (
        <div id='type-of-bean-sec'>
            <h2 className='text-orangeIs font-gotham-bold text-uppercase'>
                Type of bean
            </h2>
            <ul className='font-gotham-bold text-capitalize'>
                {typeOfBeansLinks.map(link => (
                    <li key={link.id}>
                        <Link
                            to={`/recipes/${link.slug}`}
                            className={getActive(link.slug)}
                        >
                            {link.text}
                        </Link>
                        <div className='arrow-tab'></div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TypeOfBean;

//